import * as React from "react";

const DoctorIcon = ({ bgColor, skinColor, hairColor, shadeColor }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="55.5 55.5 314.1 344.9">
    <g id="__id526_s0n7ekcsn">
      <path
        id="__id527_s0n7ekcsn"
        fill={bgColor}
        d="M369.65 212.6c0 86.74-70.31 157.05-157.05 157.05S55.55 299.34 55.55 212.6c-.003-86.74 70.31-157.05 157.05-157.05 86.74-.003 157.05 70.31 157.05 157.05"
      ></path>
      <path
        id="__id528_s0n7ekcsn"
        fill={hairColor}
        d="M213.52 347.34c-9.57 0-19.05-1.79-28.02-5.09-6.95-2.56-13.59-8.09-21.17-7.68-13.92.76-31.93 1.97-36.93-15.23-4.96-17.06 13.7-28.06 15.13-43.97 1.33-14.71-21.41-18.46-15.41-34.53 1.31-3.51 4.27-6.66 4.77-10.5.57-4.26-1.25-7.93-1.91-12-2.18-13.57 8.67-32.46 19.6-39.94 14.58-9.98 32.61-12.31 49.56-15.56 22.24-4.28 46.4-10.7 67.37-1.5 11.74 5.16 26.4 10.14 30.19 23.38 4.01 14.03 9.28 28.3 1.18 42.01-4.56 7.73-12.48 11.02-9.48 20.72 2.22 7.19 9.76 11.43 11.59 18.89 4.15 16.89-20.77 21-13.87 36.89 3.56 8.19 8.61 12.95 5.4 22.64-2.33 7.04-8.34 10.51-15.51 10.97-5.56.35-10.83-1.59-16.46-.63-3.9.67-7.03 2.48-10.66 3.96-11.06 4.51-23.42 7.17-35.37 7.17"
      ></path>
      <path
        id="__id529_s0n7ekcsn"
        fill="#FFF"
        d="M304.23 370.08a152.3 152.3 0 0 1-28.96 17.01c-19.13 8.58-40.34 13.35-62.67 13.35s-43.53-4.77-62.66-13.35c-1.37-.61-2.72-1.23-4.05-1.88-8.81-4.26-17.15-9.33-24.91-15.13 1.36-30.36 17.49-56.88 41.38-72.54 14.43-9.47 31.69-14.97 50.24-14.97 2.83 0 5.63.13 8.38.38a91.04 91.04 0 0 1 41.86 14.59c11 7.21 20.35 16.72 27.37 27.84 8.24 13.05 13.27 28.32 14.02 44.7"
      ></path>
      <path
        id="__id530_s0n7ekcsn"
        fill={skinColor}
        d="M262.84 297.54a50.44 50.44 0 0 1-12.98 27.64c-9.26 10.03-22.52 16.32-37.26 16.32-23.61 0-43.45-16.15-49.08-38.01-.5-1.94-.89-3.93-1.16-5.95 14.43-9.47 31.69-14.97 50.24-14.97 2.83 0 5.63.12 8.39.38.48.04.96.09 1.43.14.3.03.6.06.89.1.33.03.66.08.98.12.2.02.41.05.61.08.29.03.59.08.89.12.23.03.46.07.7.1.2.03.4.06.6.1.34.05.67.11 1.01.16 1.46.25 2.91.53 4.34.85l.96.21c.18.05.37.09.55.14.34.08.69.16 1.02.25q.09.015.15.03c.43.11.86.22 1.28.34.46.11.91.24 1.35.37.51.14 1.01.29 1.52.44.39.12.78.24 1.17.37.25.08.51.16.75.24.41.13.82.27 1.22.41.5.17.99.34 1.48.52.04.02.07.03.1.04.51.18 1.01.37 1.51.56.37.15.75.29 1.13.45.99.39 1.96.8 2.92 1.22l1.26.57c.38.17.76.35 1.14.53.35.17.69.33 1.03.5.32.15.63.31.94.47.2.1.41.2.61.31a80 80 0 0 1 3.31 1.79c.19.11.37.21.55.31l.68.4.69.42.45.27c.43.25.85.51 1.27.78.46.29.91.58 1.36.88"
      ></path>
      <path
        id="__id531_s0n7ekcsn"
        fill={skinColor}
        d="M230.26 262.02v34.74c0 8.79-7.19 15.99-15.97 15.99h-3.38c-8.78 0-15.96-7.2-15.96-15.99v-34.74c0-8.79 7.18-15.98 15.96-15.98h3.38c8.78 0 15.97 7.19 15.97 15.98"
      ></path>
      <path
        id="__id532_s0n7ekcsn"
        fill={shadeColor}
        d="M230.26 262.02v18.38c-5.25 2.92-10.82 4.62-16.47 4.62-6.67 0-13.03-1.86-18.84-5.09v-17.91c0-8.79 7.18-15.98 15.96-15.98h3.38c8.78 0 15.97 7.19 15.97 15.98"
      ></path>
      <path
        id="__id533_s0n7ekcsn"
        fill={skinColor}
        d="M267.05 240.48s10.46-3.56 17.14-15.22c7.26-12.66 2.7-20.55 1.26-22.26-3.93-4.67-10-1.67-11 0s-15.48 27.97-7.4 37.48"
      ></path>
      <path
        id="__id534_s0n7ekcsn"
        fill={shadeColor}
        d="M277.3 207.15s6.64.85 4.31 10.18c-2.34 9.34-8.47 13.03-16.81 17.8-8.33 4.77 4.17-26.08 12.5-27.98"
      ></path>
      <path
        id="__id535_s0n7ekcsn"
        fill={skinColor}
        d="M160.87 240.48s-10.46-3.56-17.14-15.22c-7.27-12.66-2.71-20.55-1.27-22.26 3.93-4.67 10-1.67 11 0s15.49 27.97 7.41 37.48"
      ></path>
      <path
        id="__id536_s0n7ekcsn"
        fill={shadeColor}
        d="M150.61 207.15s-6.63.85-4.3 10.18c2.33 9.34 8.47 13.03 16.8 17.8 8.34 4.77-4.16-26.08-12.5-27.98"
      ></path>
      <path
        id="__id537_s0n7ekcsn"
        fill={skinColor}
        d="M277.3 200.99c0-38.33-28.29-69.41-63.2-69.41-34.9 0-63.21 31.08-63.21 69.41s28.31 78.4 63.21 78.4c32.8 0 63.2-40.39 63.2-78.4"
      ></path>
      <path
        id="__id538_s0n7ekcsn"
        fill={hairColor}
        d="M293.62 187.95c2.94-6.95.95-15.4-.5-22.22-3.07-14.48-12.55-28.23-28.12-31.38-7.43-1.5-14.84-3.03-21.48-7.64-6.06-4.21-11.81-9.86-18.63-12.75-13.34-5.63-30.76-1.74-34.27 13.99-.15.66-.29 1.36-.41 2.09l-.2-2.2c-1.12 8.64-1.09 14.57 4.12 21.97 5.36 7.61 12.46 9.08 20.88 10 18.01 1.97 21.95 13.56 26.61 28.53 2.98 9.58 10.26 20.22 21.39 18.03 5.22-1.03 9.8-4.06 14.88-5.15 5.61-1.21 7.55 2.32 11.52 5.57-.03-3.27-1.68-7.34-.8-10.33.87-2.99 3.79-5.62 5.01-8.51"
      ></path>
      <path
        id="__id539_s0n7ekcsn"
        fill={hairColor}
        d="M198.02 139.81c-1.08-3.09-3.23-6.46-5.49-8.96-2.94-3.24-1.91-2.9-5.52-4.01-6.46-2.42-11.24-3.84-18.01.12-5.61 3.29-8.58 8.72-10.1 14.77-1.96 7.79-3.89 11.57-10.39 17.11-5.16 4.39-8.72 9.71-11.14 16-2.81 7.3-4.66 15.99-4.36 24 .2 5.34 1.55 16.96 5.4 20.45.9-8.55 3.43-13.29 11.98-15.56 7.3-1.93 13.56-2.92 15.63-11.38 1.87-7.62 2.34-13.97 9.49-19.39 5.9-4.47 14.13-6.03 19.11-11.59 5.17-5.8 5.9-14.45 3.4-21.56"
      ></path>
    </g>
  </svg>
);

export default DoctorIcon;
